<template>
    <span :class="'more-items-tip' + (clazz ? ' ' + clazz : '')">
        <span
            v-if="list.length > 0 && orgList.length == 0"
            v-tip:second.hover
            class="more-items-tip__title"
        >等{{ list.length }}{{ unit }}</span>
        <span
            v-if="list.length == 0 && orgList.length > 0"
            v-tip:second.hover
            class="more-items-tip__title"
        >等{{ orgList.length }}部门</span>
        <span
            v-if="list.length > 0 && orgList.length > 0"
            v-tip:second.hover
            class="more-items-tip__title"
        >等{{ orgList.length }}部门/{{ list.length }}{{ unit }}</span>

        <v-tip
            ref="second"
            placement="top"
            kind="large"
        >
            <div class="more-items-tip-content">
                <div
                    v-for="(singleList, index) in displayList"
                    :key="'singleList' + index"
                    :class="{
                        'more-items-tip-content__single': true,
                        'more-items-tip-content__not-last': index < displayList.length - 1
                    }"
                >
                    <div
                        v-for="(item, ind) in singleList"
                        :key="'item-' + index + '-' + ind"
                        class="more-items-tip-content__item"
                    >
                        {{ item }}
                    </div>
                </div>
            </div>
        </v-tip>
    </span>
</template>

<script>
import { Icon } from 'vhtml-ui';
/* eslint-disable */

const req = require.context('@/assets/icons', false, /[^\.]+\.svg$/);
Icon.addSprites(req);

export default {
    name: 'MoreItemsTip',
    props: {
        list: {
            type: Array,
            default: []
        },
         orgList: {
            type: Array,
            default: function() {
                return [];
            }
        },
        clazz: {
            type: String,
            default: ''
        },
        unit: {
            type: String,
            default: ''
        },
        maxNum: {
            type: Number,
            default: 22
        },
        singleLineNum: {
            type: Number,
            default: 11
        }
    },
    data() {
        const displayList = [];
        const orgName = [];

        let singleLine;
        let orgLine;
        const displayNum = this.list.length + this.orgList.length <= this.maxNum ? this.list.length + this.orgList.length : this.maxNum;
        let i;
        for (i = 0; i < displayNum; i++) {
            if (i % this.singleLineNum == 0) {
                if (singleLine) displayList.push(singleLine);
                singleLine = [];
            }
            let allList = this.orgList.concat(this.list);
            singleLine.push(allList[i]);

            //   if (i % this.singleLineNum == 0) {
            //     if (orgLine) orgName.push(orgLine);
            //     orgLine = [];
            // }
            // orgLine.push(this.orgList[i]);

        }
        if (singleLine) {
            if (this.list.length + this.orgList.length > this.maxNum) {
             if(this.list.length>0 && this.orgList.length==0) {
                singleLine[this.singleLineNum - 1] = `等${this.list.length}${this.unit}…`;
             }else if(this.list.length==0 && this.orgList.length>0) {
                singleLine[this.singleLineNum - 1] = `等${this.list.orgList}部门`;
             }else {
                singleLine[this.singleLineNum - 1] = `等${this.orgList.length}部门/${this.list.length}${this.unit}…`;

             }
            }
            displayList.push(singleLine);
            // orgName.push(orgLine);
        }
        return {
            displayList,
            // orgName
        };
    },
    computed: {},
    mounted() {},
    methods: {}
};
</script>

<style lang="less">
@import '~@/common/common';

.more-items-tip {
    &__title {
        font-size: 14px;
        color: @mainLightGray;
        &:hover {
            color: @mainBlack;
        }
    }
}
.more-items-tip-content {
    overflow: hidden;
    &__single {
        float: left;
        width: 130px;
    }
    &__not-last {
        margin-right: 10px;
    }
    &__item {
        // max-width: 90px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
}
</style>
